<script lang="ts">
	import BillingPeriod from '$lib/components/billing-period.svelte';
	import PricingPlan from '$lib/components/pricing-plan.svelte';

	let { content } = $props();
	let annually = $state(true);
	let billingPeriod = $derived(annually ? 'annually' : 'monthly');
</script>

<div class="mt-[-96px] flex flex-col gap-8">
	<BillingPeriod bind:annually />

	<div class="flex flex-row flex-wrap justify-center gap-4">
		{#each content.plans.slice(0, 4) as plan}
			<PricingPlan {plan} {billingPeriod} enableHover />
		{/each}
	</div>

	<p class="mt-6 text-center text-3xl font-semibold">Add-ons</p>

	<div class="mt-6 flex flex-row flex-wrap justify-center gap-4">
		{#each content.plans.slice(4) as plan}
			<PricingPlan {plan} {billingPeriod} enableHover />
		{/each}
	</div>
</div>
